<template>
  <div class="flex mb-11 text-xl font-bold text-text leading-tight px-3 lg:px-0">
    <span class="mr-auto">{{ $t('myAccounts') }}</span>
    <LoaderBlock class="h-7 w-50" v-if="dirty"/>
    <span v-else class="pr-3-5 lg:pr-0" v-html="balance"></span>
  </div>
</template>

<script>
import LoaderBlock from "@/components/UI/LoaderBlock";

export default {
  name: "MyAccountsTitle",
  components: {LoaderBlock},
  props: {
    dirty: {
      type: Boolean,
      required: true
    },
    balance: {
      type: String
    }
  },
  i18n: {
    messages: {
      en: {
        myAccounts: 'My accounts',
      },
      ru: {
        myAccounts: 'Мои счета',
      }
    }
  }
}
</script>

<style scoped>

</style>